import { useEffect } from "react";
import { MdClose } from "react-icons/md";
import "./AddEditPackageModal.css";

function AddEditPackageModal({
  isOpen,
  onClose,
  formData,
  updateField,
  submitForm,
  loading,
  editingPackage,
}) {

  useEffect(() => {

    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };

  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {

    e.preventDefault();

    const success = await submitForm();

    if (success) {
      onClose();
    }

  };

  return (

    <div className="package-modal-overlay">

      <div className="package-modal">

        <div className="package-modal-header">

          <h2>
            {editingPackage
              ? "Edit Catering Package"
              : "Add Catering Package"}
          </h2>

          <button
            type="button"
            className="package-close-btn"
            onClick={onClose}
          >
            <MdClose />
          </button>

        </div>

        <form
          className="package-form"
          onSubmit={handleSubmit}
        >

          <div className="form-group full-width">
            <label>Package Name</label>

            <input
              type="text"
              value={formData.packageName}
              onChange={(e) =>
                updateField("packageName", e.target.value)
              }
              required
            />
          </div>

          <div className="form-group full-width">

            <label>Description</label>

            <textarea
              value={formData.description}
              onChange={(e) =>
                updateField("description", e.target.value)
              }
            />

          </div>

          <div className="form-group">

            <label>Category</label>

            <select
              value={formData.category}
              onChange={(e) =>
                updateField("category", e.target.value)
              }
            >
              <option>Wedding</option>
              <option>Birthday</option>
              <option>Corporate</option>
              <option>Festival</option>
              <option>Housewarming</option>
              <option>Custom</option>
            </select>

          </div>

          <div className="form-group">

            <label>Food Type</label>

            <select
              value={formData.foodType}
              onChange={(e) =>
                updateField("foodType", e.target.value)
              }
            >
              <option>Veg</option>
              <option>Non Veg</option>
              <option>Both</option>
            </select>

          </div>

          <div className="form-group">

            <label>Price Per Plate</label>

            <input
              type="number"
              value={formData.pricePerPlate}
              onChange={(e) =>
                updateField("pricePerPlate", e.target.value)
              }
            />

          </div>

          <div className="form-group">

            <label>Minimum Guests</label>

            <input
              type="number"
              value={formData.minimumGuests}
              onChange={(e) =>
                updateField("minimumGuests", e.target.value)
              }
            />

          </div>

          <div className="form-group">

            <label>Maximum Guests</label>

            <input
              type="number"
              value={formData.maximumGuests}
              onChange={(e) =>
                updateField("maximumGuests", e.target.value)
              }
            />

          </div>

          <div className="form-group">

            <label>Preparation Time (mins)</label>

            <input
              type="number"
              value={formData.preparationTime}
              onChange={(e) =>
                updateField("preparationTime", e.target.value)
              }
            />

          </div>

          <div className="form-group full-width">

            <label>Advance Booking Days</label>

            <input
              type="number"
              value={formData.advanceBookingDays}
              onChange={(e) =>
                updateField("advanceBookingDays", e.target.value)
              }
            />

          </div>

          <div className="form-group full-width">

            <label>Menu Items</label>

            <textarea
              placeholder="Comma separated"
              value={formData.menuItems}
              onChange={(e) =>
                updateField("menuItems", e.target.value)
              }
            />

          </div>

          <div className="form-group full-width">

            <label>Package Image</label>

            <input
              type="file"
              accept="image/*"
              onChange={(e) =>
                updateField("image", e.target.files[0])
              }
            />

          </div>

          <div className="modal-actions">

            <button
              type="button"
              className="cancel-btn"
              onClick={onClose}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="save-btn"
              disabled={loading}
            >
              {loading
                ? "Saving..."
                : editingPackage
                ? "Update Package"
                : "Add Package"}
            </button>

          </div>

        </form>

      </div>

    </div>

  );

}

export default AddEditPackageModal;